export default {"src":"/_next/static/media/key.49602230.svg","height":25,"width":25};